import { QuozRO } from '@routellers/types/dist/translation/quiz.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = number;

type ResponseData = QuozRO;

export const quizSkip: ApiMethodDeclaration<ParamsData, ResponseData> = (id) => ({
    url: `/translations/quiz-skip/${id}`,
    method: 'GET',
});
